import { render, staticRenderFns } from "./DailyTopPerformance.vue?vue&type=template&id=5d0c1dae&"
import script from "./DailyTopPerformance.vue?vue&type=script&lang=js&"
export * from "./DailyTopPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports